<template>
  <div class="home">
    <SideBar></SideBar>
    <div class="home-content">
      <PageHeader/>
      <div class="page-content">
        <a-breadcrumb>
          <a-breadcrumb-item
            class="breadcrumb-item"
            v-for="(text, index) in breadcrumb"
            :key="index"
            @click="clickBread(index)">{{ text }}</a-breadcrumb-item>
        </a-breadcrumb>
        <router-view class="router-page"></router-view>
      </div>
    </div>
    <RoleSelector/>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar'
import PageHeader from '@/components/PageHeader'
import RoleSelector from '@/components/RoleSelector'

export default {
  name: 'Home',
  components: {
    SideBar,
    PageHeader,
    RoleSelector
  },
  computed: {
    breadcrumb () {
      if (this.$route.name === 'itemList') {
        return ['数据管理', '数据集', this.$store.state.breadDatasetName]
      } else {
        return this.$route.meta.breadcrumb || []
      }
    }
  },
  created () {
    this.getFrequentData()
  },
  methods: {
    async getFrequentData () {
      const hide = this.$message.loading('获取数据中...', 0)
      try {
        await this.$store.dispatch('getMyInfo')
        await this.$store.dispatch('getOptionalRoles')
        await this.$store.dispatch('getFrequencyData')
      } catch {
        console.log('get info failed')
      } finally {
        hide()
      }
    },
    // 仅数据集详情页面，点击面包屑返回数据集页面
    clickBread (index) {
      if (this.$route.name === 'itemList' && index === 1) {
        this.$router.push({
          name: 'dataSet'
        })
      }
    }
  }
}
</script>
<style lang="less">
.home {
  height: 100%;
  display: flex;
  text-align: left;
  @topHeight: 60px;
  .home-content {
    width: calc(100% - 160px);
    .page-content {
      .ant-breadcrumb {
        padding: 10px; height: 40px;
        cursor: pointer;
      }
      .router-page {
        height: calc(100% - @topHeight - 40px);
        margin: 10px;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
        // 代替tab
        .data-type-filter {
          display: flex;
          .data-type {
            border-bottom: 2px solid transparent;
            margin-right: 20px; padding: 0 5px;
            height: 30px; line-height: 30px;
            cursor: pointer;
          }
          .active-type {
            border-bottom-color: @theme;
            color: @theme;
          }
        }
        .table-title {
          margin-bottom: 20px;
          display: flex; justify-content: flex-end; align-items: center;
          .table-name {
            margin-right: auto;
            font-size: 18px; color: #000;
          }
        }
        // 详情页面 标题 + 返回
        // 详情页面的标题
        .detail-page-title {
          display: flex; align-items: center;
          padding: 10px 0;
          border-bottom: 1px solid #999;
          .title {
            margin: 0 20px 0 0;
          }
        }
        .filter-section {
          display: flex; align-items: center; flex-wrap: wrap;
          .ant-btn, .ant-select, .ant-input-number, .ant-input {
            margin-right: 10px;
          }
          .ant-form-inline .ant-form-item {
            margin-right: 10px;
          }
          .ant-input-affix-wrapper {
            width: auto;
          }
          .label {
            margin-right: 10px;
          }
          .ant-select {
            width: 140px;
          }
          .ant-select-selector {
            width: 140px;
          }
        }
        .ant-pagination {
          text-align: right;
        }
        // 表格中的操作按钮
        .gap-btn {
          margin: 0 5px;
        }
        // 详情页面表单
        .detail-form {
          padding: 20px;
          width: 800px;
        }
      }
    }
  }
}
</style>
